import MappingRule from './MappingRule';

export default MappingRule;
